import { PureComponent } from 'react'
import { usePapaParse } from 'react-papaparse';

import { Table, OverlayTrigger, Tooltip, Row, Col, Button } from 'react-bootstrap';

import { str_no_exams_available, default_load_button_info_tooltip_timeout, title_exams } from '../Consts';

import './Exams.css';

function makeid(length) {
    let result = '';
    const characters = 'xyzpqrkdefghijmnoabcstuvw';
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
        counter += 1;
    }
    return result;
}

export class Exams extends PureComponent {


    constructor(props) {
        super(props);
        this.state = {
            showLoadAnimation: false,
        };
    }

    componentDidMount() {
        this.handleQueryParams();
    }

    componentDidUpdate(prevProps) {
        if (this.props.location.search !== prevProps.location.search) {
            this.handleQueryParams();
        }
    }

    handleQueryParams = () => {
        const { location } = this.props;
        const queryParams = new URLSearchParams(location.search);
        const triggerParam = queryParams.get('trigger');

        if (triggerParam === 'load') {
            // console.log("Triggered load");
            this.setState({ showLoadAnimation: true });

            setTimeout(() => {
                this.setState({ showLoadAnimation: false });
            }, default_load_button_info_tooltip_timeout);
        }
    }

    handleUploadButtonClick = () => {
        document.getElementById('inputFileUpload').click();
    };

    handleUploadLabelClick = (e) => {
        e.stopPropagation();
    };

    handleFileSaveChange = (e, x) => {
        e.preventDefault();
        if (e.target.files.length > 0) {
            const files = e.target.files;
            const file = files[0];
            if (file.type.startsWith("application/json")) {
                const reader = new FileReader();
                reader.onloadend = (function (theFile) {
                    return function (e) {

                        try {
                            if (e.target.readyState === FileReader.DONE) {
                                const fContentParsed = JSON.parse(e.target.result);
                                fContentParsed["fileName"] = file.name;

                                for (let i = 0; i < fContentParsed.grid.length; i++) {
                                    fContentParsed.grid[i][0] = { value: makeid(5) };
                                    fContentParsed.grid[i][1] = { value: makeid(5) };
                                }

                                const numTasks = fContentParsed.abereiche[0].length;

                                if (!fContentParsed.hasOwnProperty('taskNames') ||
                                    fContentParsed.taskNames[0][2].value.length === 0) {
                                    fContentParsed['taskNames'] = [];
                                    fContentParsed['taskNames'][0] = [];
                                    fContentParsed['taskNames'][0][0] = { value: "" };
                                    fContentParsed['taskNames'][0][1] = { value: "" };

                                    for (let i = 2; i < numTasks; i++) {
                                        fContentParsed['taskNames'][0][i] = { value: "A" + (i - 1) };
                                    }
                                }

                                for (var i = 2; i < numTasks; i++) {
                                    const sanitizer = fContentParsed['maxPunkte'][0][i].value;
                                    if (typeof sanitizer === 'string' || sanitizer instanceof String) {
                                        fContentParsed['maxPunkte'][0][i].value = sanitizer.replace(/,/g, '.');
                                    }
                                }

                                if (x.props.parentState.klassenarbeiten.length === 0) {
                                    x.props.backCallerUploadExam(fContentParsed);
                                    x.props.backCallerSetNotice("Klassenarbeit " + file.name + " erfolgreich geladen.",
                                        "Klassenarbeit geladen",
                                        "info"
                                    );
                                } else {
                                    const e1 = x.props.parentState.klassenarbeiten[0];
                                    const protoExam = e1.maxPunkte[0].slice(2, -1);
                                    const newExam = fContentParsed.maxPunkte[0].slice(2, -1);

                                    if (protoExam.length !== newExam.length) {
                                        x.props.backCallerSetNotice("Klassenarbeit " + file.name +
                                            " nicht geladen. Die Anzahl der Aufgaben passen nicht zusammen.",
                                            "Klassenarbeit nicht geladen",
                                            "warning");
                                    } else {
                                        let fits = 0;
                                        for (let i = 0; i < protoExam.length; i++) {
                                            if (protoExam[i].value !== newExam[i].value) {
                                                fits = 1;
                                                break;
                                            }
                                        }
                                        if (fits !== 0) {
                                            x.props.backCallerSetNotice("Klassenarbeit " + file.name +
                                                " nicht geladen. Die Punkte der einzelnen Aufgaben stimmen nicht überein.",
                                                "Klassenarbeit nicht geladen",
                                                "warning");
                                        } else {
                                            x.props.backCallerUploadExam(fContentParsed);
                                            x.props.backCallerSetNotice("Klassenarbeit " + file.name + " erfolgreich geladen.",
                                                "Klassenarbeit geladen",
                                                "info"
                                            );
                                        }
                                    }
                                }
                            }
                        } catch (error) {
                            console.error("An error occurred while processing the file:", error);
                            x.props.backCallerSetNotice("Ein Fehler ist beim Laden der Klassenarbeit " + file.name + " aufgetreten.",
                                "Fehler beim Laden",
                                "danger"
                            );
                        }
                    };
                })(file);
                reader.readAsText(file);
            }
            else if (file.type.startsWith("text/csv")) {
                const reader = new FileReader();
                reader.onloadend = (function (theFile) {
                    return function (e) {
                        if (e.target.readyState === FileReader.DONE) {
                            const { readString } = usePapaParse();
                            readString(e.target.result, {
                                header: true,
                                dynamicTyping: true,
                                comments: "#",
                                complete: (results) => {
                                    try {
                                        let numFields = results.meta.fields.length;
                                        let numTasks = numFields - 9;
                                        // let maxPoints = results.meta.fields[8].split("/")[1];
                                        let maxPointsObjName = results.meta.fields[8];

                                        let maxPunkte = [];
                                        let taskNames = [];
                                        for (let i = 9; i < numFields; i++) {
                                            maxPunkte.push(
                                                parseFloat(results.meta.fields[i].split("/")[1].replace(',', '.').replace(' ', '')));
                                            taskNames.push(results.meta.fields[i]);
                                        }
                                        maxPunkte.push(
                                            parseFloat(results.meta.fields[8].split("/")[1].replace(',', '.').replace(' ', '')));

                                        let ka = {
                                            "fileName": file.name,
                                            // "klasse": "Dummy Klasse",
                                            "klasse": file.name,
                                            "schuljahr": "",
                                            "fach": "",
                                            "notenschluessel": "23.5",
                                        };

                                        ka["maxPunkte"] = [];
                                        ka["maxPunkte"][0] = [];
                                        ka["maxPunkte"][0][0] = { value: '' };
                                        ka["maxPunkte"][0][1] = { value: '' };
                                        for (let i = 2; i < numTasks + 3; i++) {
                                            ka['maxPunkte'][0][i] = { value: maxPunkte[i - 2] };
                                        }

                                        ka["abereiche"] = [];
                                        ka["abereiche"][0] = [];
                                        ka["abereiche"][0][0] = { value: '' };
                                        ka["abereiche"][0][1] = { value: '' };
                                        for (let i = 2; i < numTasks + 2; i++) {
                                            ka['abereiche'][0][i] = { value: 'I' };
                                        }

                                        ka["taskNames"] = [];
                                        ka["taskNames"][0] = [];
                                        ka["taskNames"][0][0] = { value: '' };
                                        ka["taskNames"][0][1] = { value: '' };
                                        for (let i = 2; i < numTasks + 2; i++) {
                                            ka['taskNames'][0][i] = { value: 'A' + (i - 1) };
                                        }

                                        ka["namelessColsMaxPunkte"] = [];
                                        ka["namelessColsMaxPunkte"][0] = [];
                                        ka["namelessColsMaxPunkte"][0][0] = { value: ' ', width: "100px" };
                                        ka["namelessColsMaxPunkte"][0][1] = { value: ' ', width: "100px" };
                                        for (let i = 2; i < numTasks + 2; i++) {
                                            ka['namelessColsMaxPunkte'][0][i] = { value: 'A' + (i - 1), width: "50px" };
                                        }
                                        ka['namelessColsMaxPunkte'][0][numTasks + 2] = { value: 'Summe', width: "50px" };

                                        ka["namelessColsAbereiche"] = [];
                                        ka["namelessColsAbereiche"][0] = [];
                                        ka["namelessColsAbereiche"][0][0] = { value: ' ', width: "100px" };
                                        ka["namelessColsAbereiche"][0][1] = { value: ' ', width: "100px" };
                                        for (let i = 2; i < numTasks + 2; i++) {
                                            ka['namelessColsAbereiche'][0][i] = { value: 'A' + (i - 1), width: "50px" };
                                        }

                                        ka["columns"] = [];
                                        ka["columns"][0] = [];
                                        ka["columns"][0][0] = { value: 'Name', width: "100px" };
                                        ka["columns"][0][1] = { value: 'Vorname', width: "100px" };
                                        for (let i = 2; i < numTasks + 2; i++) {
                                            ka['columns'][0][i] = { value: 'A' + (i - 1), width: "50px" };
                                        }
                                        ka['columns'][0][numTasks + 2] = { value: 'Summe', width: "50px" };
                                        ka['columns'][0][numTasks + 3] = { value: 'Note', width: "50px" };

                                        ka["grid"] = [];
                                        // ka["grid"][0] = [];
                                        for (let i = 0; i < results.data.length - 2; i++) {
                                            ka['grid'][i] = [];
                                            // ka['grid'][i][0] = { value: results.data[i]["Nachname"] };
                                            // ka['grid'][i][1] = { value: results.data[i]["Vorname"] };
                                            ka['grid'][i][0] = { value: makeid(5) };
                                            ka['grid'][i][1] = { value: makeid(5) };
                                            for (let j = 4; j < numTasks + 4; j++) {
                                                let theNumber = results.data[i][taskNames[j - 4]];
                                                theNumber = parseFloat(theNumber.replace(',', '.').replace(' ', ''));
                                                if (isNaN(theNumber)) {
                                                    theNumber = 0;
                                                }
                                                ka['grid'][i][j - 2] = { value: theNumber };
                                            }
                                            let theSumPoints = results.data[i][maxPointsObjName];
                                            ka['grid'][i][numTasks + 2] = { value: parseFloat(theSumPoints.replace(',', '.').replace(' ', '')) };
                                            ka['grid'][i][numTasks + 3] = { value: 6.66 };
                                        }

                                        if (x.props.parentState.klassenarbeiten.length === 0) {
                                            x.props.backCallerUploadExam(ka);
                                            x.props.backCallerSetNotice("Klassenarbeit " + file.name + " erfolgreich geladen.",
                                                "Klassenarbeit geladen",
                                                "info"
                                            );
                                        }
                                        else {
                                            const e1 = x.props.parentState.klassenarbeiten[0];
                                            const protoExam = e1.maxPunkte[0].slice(2, -1);
                                            const newExam = ka.maxPunkte[0].slice(2, -1);

                                            if (protoExam.length !== newExam.length) {
                                                x.props.backCallerSetNotice("Klassenarbeit " + file.name +
                                                    " nicht geladen. Die Anzahl der Aufgaben passen nicht zusammen.",
                                                    "Klassenarbeit nicht geladen",
                                                    "warning");
                                            }
                                            else {
                                                let fits = 0;
                                                for (let i = 0; i < protoExam.length; i++) {
                                                    if (protoExam[i].value !== newExam[i].value) {
                                                        fits = 1;
                                                        break;
                                                    }
                                                }
                                                if (fits !== 0) {
                                                    x.props.backCallerSetNotice("Klassenarbeit " + file.name +
                                                        " nicht geladen. Die Punkte der einzelnen Aufgaben stimmen nicht überein.",
                                                        "Klassenarbeit nicht geladen",
                                                        "warning");
                                                }
                                                else {
                                                    x.props.backCallerUploadExam(ka);
                                                    x.props.backCallerSetNotice("Klassenarbeit " + file.name + " erfolgreich geladen.",
                                                        "Klassenarbeit geladen",
                                                        "info"
                                                    );
                                                }
                                            }
                                        }
                                    }
                                    catch (error) {
                                        // console.error(error);
                                        x.props.backCallerSetNotice("Klassenarbeit " + file.name + " konnte nicht geladen werden. Bitte überprüfen Sie das Dateiformat.",
                                            "Klassenarbeit nicht geladen",
                                            "danger"
                                        );
                                    }
                                }
                            });
                        }
                    };
                })(file);
                reader.readAsText(file);
            }
            else {
                x.props.backCallerSetNotice(
                    "Die Datei " + file.name + " wurde nicht akzeptiert. Sie können nur Klassenarbeiten aus dem examer-Erfassungswerkzeug oder moodle-Exporte einspielen.",
                    "Falsches Dateiformat",
                    "warning"
                );
            }
            e.target.value = "";
        }
    }

    handleRemoveExam = (fileName, index) => {
        const ret = {
            header: "Klassenarbeit entfernen?",
            body: "Möchten Sie die Klassenarbeit " + fileName + " wirklich entfernen?",
            footer_cancel: "Abbrechen",
            footer_confirm: "Entfernen",
            // method_confirm: null,
            visible: true,
        }
        this.props.backCallerHandleRemoveExam(ret, index, fileName);
    }

    render() {
        return (
            <>
                {/* <Container fluid> */}
                <h5>{title_exams}</h5>
                {this.props.parentState.klassenarbeiten.length === 0 &&
                    <h6>{str_no_exams_available}</h6>
                }

                {this.props.parentState.klassenarbeiten.length > 0 &&
                    <Row className="mt-3">
                        <Col>
                            <Table striped bordered hover size="sm" >
                                <thead>
                                    {/* <tr><th>Dateiname</th><th>Jahr</th><th>Fach</th><th>Klasse</th>
                                            <th>Anzahl Sch&uuml;ler</th><th>Anzahl Aufgaben</th><th>Maximale Punkte</th>
                                            <th>&nbsp;</th></tr> */}
                                    <tr><th>Dateiname</th><th>Jahr</th><th>Fach</th><th>Klasse</th>
                                        <th>Sch&uuml;ler</th><th>Aufgaben</th><th>Punkte</th>
                                        <th>&nbsp;</th></tr>
                                </thead>
                                <tbody>
                                    {this.props.parentState.klassenarbeiten.map((
                                        { schuljahr, fach, klasse, maxPunkte, grid, fileName, ...rest }, index) => {
                                        return (
                                            <tr key={index}>
                                                <td>{fileName}</td>
                                                <td>{schuljahr}</td>
                                                <td>{fach}</td>
                                                <td>{klasse}</td>
                                                <td>{grid.length}</td>
                                                <td>{maxPunkte[0].length - 3}</td>
                                                <td>{maxPunkte[0][maxPunkte[0].length - 1].value}</td>
                                                <td className="text-center">
                                                    <Button variant="outline-primary" size="sm"
                                                        onClick={(e) => this.handleRemoveExam(fileName, index)}>
                                                        Klassenarbeit entfernen
                                                    </Button>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                }
                {/* </Container> */}

                {/* <label className="pointerFinger" htmlFor="inputFileUpload">
                    <a>
                        <i className="ico">&#x2B06;</i>
                        <i className="txt">Klassenarbeit laden</i>
                        <input id="inputFileUpload" type="file" onChange={e => this.handleFileSaveChange(e, this)} />
                    </a>
                </label> */}

                {/* <button className="buttonUpload">
                    <label className="pointerFinger" htmlFor="inputFileUpload">
                        &#x2B06; Eine Klassenarbeit von Ihrem lokalen Dateisystem in das System laden
                        <input id="inputFileUpload" type="file" onChange={e => this.handleFileSaveChange(e, this)} />
                    </label>
                </button> */}
                {/* 
                <div className="d-flex justify-content-start">
                    <Button variant="outline-primary" size="sm" className="button-hover-white"
                        onClick={this.handleUploadButtonClick}>
                        <label className="pointerFinger button-hover-white" htmlFor="inputFileUpload"
                            onClick={this.handleUploadLabelClick}>
                            Klassenarbeit laden
                            <input id="inputFileUpload" type="file" onChange={e => this.handleFileSaveChange(e, this)} />
                        </label>
                    </Button>
                </div> */}

                <div className="d-flex justify-content-start">
                    <OverlayTrigger
                        placement="bottom"
                        overlay={<Tooltip className="exam-load-tooltip" id="tooltip-bottom">Bitte klicken Sie hier, um eine Klassenarbeit zu laden. Sie können nur Klassenarbeiten öffnen, welche mit dem Examer bearbeitet wurden.</Tooltip>}
                        show={this.state.showLoadAnimation}
                    >
                        <Button
                            variant="outline-primary"
                            size="sm"
                            className={`button-hover-white ${this.state.showLoadAnimation ? 'blinking' : ''}`}
                            onClick={this.handleUploadButtonClick}
                        >
                            <label
                                className="pointerFinger button-hover-white"
                                htmlFor="inputFileUpload"
                                onClick={this.handleUploadLabelClick}
                            >
                                Klassenarbeit laden
                                <input
                                    id="inputFileUpload"
                                    type="file"
                                    accept=".json,.csv"
                                    onChange={e => this.handleFileSaveChange(e, this)}
                                    style={{ display: 'none' }}
                                />
                            </label>
                        </Button>
                    </OverlayTrigger>
                </div>
            </>
        )
    }
}